<template>
  <component
    :key="link"
    :is="tag"
    v-bind="tagAttr"
    class="c-search-result"
    :class="[
      `c-search-result--${type.toLowerCase()}`,
      { 'inactive': !link }
    ]"
  >
    <div :class="getClassName()">
      <div class="c-search-result__type" v-html="type"/>
      <div class="c-search-result__title" v-md-html="title"/>
      <div v-if="description" class="c-search-result__desc" v-md-html="description" />
      <div v-if="unit" class="c-search-result__unit" v-html="unit.name"/>
      <div v-if="fullTags && fullTags.length" class="c-search-tile__tags">
        <span v-for="tag in fullTags" :key="`${type}${tag.label}`">
          #{{ tag.label }}
        </span>
      </div>
    </div>
  </component>
</template>

<script>
import mdHtml from './directives'

export default {
  directives: {
    'md-html': mdHtml
  },

  name: "SearchResult",

  props: {
    title: String,
    description: String,
    type: String,
    image: String,
    unitID: String,
    term: String,
    fullTags: Array,
    unit: Object,
    link: {
      type: String,
      default: undefined
    }
  },
  created() {
    this.initLinkType()
  },
  data() {
    return {
      externalLink: false,
      internalLink: false
    }
  },
  methods: {
    initLinkType() {
      if (this.link !== undefined) {
        /^(https?|http):\/\/[^\s$.?#].[^\s]*$/.test(this.link) ? this.externalLink = true : this.internalLink = true
      }
    },
    getClassName() {
      if (this.unit) {
        return `c-search-result--${this.unit.slug}`
      }
      return ''
    }
  },
  computed: {
    tagAttr() {
      if (this.externalLink) {
        return {
          href: this.link,
          target: '_blank'
        }
      }
      if (this.internalLink) {
        return {
          to: this.link
        }
      }
      return {}
    },
    tag() {
      if (this.externalLink) {
        return 'a'
      }
      if (this.internalLink) {
        return 'router-link'
      }
      return 'div'
    }
  },
  watch: {
    'link': function() {
      this.initLinkType()
    }
  }
}
</script>
